export const COMMISSION_RULE_TYPES = [
  'default',
  'commission_category',
  'service_category',
  'service',
  'product',
]

export const COMMISSION_RATE_TYPES = ['percent', 'flat']

export const COMMISSION_CATEGORIES = ['hair', 'nails', 'spa', 'beauty', 'retail']

export function commissionRuleTypeLabel(ruleType) {
  switch (ruleType) {
    case 'default':
      return 'Default (fallback)'
    case 'commission_category':
      return 'Commission category'
    case 'service_category':
      return 'Service category'
    case 'service':
      return 'Specific service'
    case 'product':
      return 'Retail product'
    default:
      return ruleType
  }
}

export function emptyCommissionRule(ruleType = 'default') {
  return {
    rule_type: ruleType,
    commission_category: 'hair',
    service_category_id: '',
    service_id: '',
    product_id: '',
    rate_type: 'percent',
    rate_value: ruleType === 'default' ? '25' : '40',
    sort: 10,
  }
}

export function emptyCommissionProfileForm() {
  return {
    name: '',
    description: '',
    is_default: false,
    is_active: true,
    rules: [emptyCommissionRule('default')],
  }
}

/**
 * @param {import('@/types/api').CommissionProfile} profile
 */
export function commissionProfileToForm(profile) {
  return {
    name: profile.name ?? '',
    description: profile.description ?? '',
    is_default: Boolean(profile.is_default),
    is_active: Boolean(profile.is_active ?? true),
    rules: (profile.rules ?? []).map((rule, index) => ({
      rule_type: rule.rule_type ?? 'default',
      commission_category: rule.commission_category ?? 'hair',
      service_category_id: rule.service_category_id ?? '',
      service_id: rule.service_id ?? '',
      product_id: rule.product_id ?? '',
      rate_type: rule.rate_type ?? 'percent',
      rate_value: String(rule.rate_value ?? ''),
      sort: rule.sort ?? (index + 1) * 10,
    })),
  }
}

/**
 * @param {ReturnType<typeof emptyCommissionProfileForm>} form
 */
export function commissionProfileFormToPayload(form) {
  return {
    name: form.name,
    description: form.description || null,
    is_default: form.is_default,
    is_active: form.is_active,
    rules: form.rules.map((rule, index) => ({
      rule_type: rule.rule_type,
      commission_category:
        rule.rule_type === 'commission_category' ? rule.commission_category : null,
      service_category_id:
        rule.rule_type === 'service_category' && rule.service_category_id !== ''
          ? Number(rule.service_category_id)
          : null,
      service_id:
        rule.rule_type === 'service' && rule.service_id !== '' ? Number(rule.service_id) : null,
      product_id:
        rule.rule_type === 'product' && rule.product_id !== '' ? Number(rule.product_id) : null,
      rate_type: rule.rate_type,
      rate_value: Number(rule.rate_value),
      sort: rule.sort ?? (index + 1) * 10,
    })),
  }
}

/**
 * @param {ReturnType<typeof emptyCommissionProfileForm>} form
 */
export function ensureDefaultRule(form) {
  const hasDefault = form.rules.some((rule) => rule.rule_type === 'default')
  if (hasDefault) return form

  return {
    ...form,
    rules: [emptyCommissionRule('default'), ...form.rules],
  }
}
